import httpClient from "./httpClient";

const IncidentTypeService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/incident-type", {
      params: { page, pageSize }
    });
  }
};

export default IncidentTypeService;
